import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { switchMap, map, catchError, take, finalize } from 'rxjs/operators';
import * as ShiftManagementActions from './shift-management.actions';
import { TShiftManagementActionType } from './shift-management.models';
import { AppNotificationUtilClass, MachineMaintenanceDataService } from '@monorepo/services';

@Injectable({ providedIn: 'root' })
export class ShiftManagementEffects {
  constructor(
    private actions$: Actions,
    private mmDataService: MachineMaintenanceDataService,
    private APIHelper: AppNotificationUtilClass,
  ) {}

  fetchAllShifts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TShiftManagementActionType.FetchAllShifts),
      switchMap((action: ShiftManagementActions.FetchAllShifts) =>
        from(this.APIHelper.presentLoading()).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action] as const),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.mmDataService.getAllShifts(action.payload).pipe(
          finalize(() => this.APIHelper.dismissLoadingV2(loaderEl)),
          map((res) => new ShiftManagementActions.FetchAllShiftsSuccess(res)),
          catchError(() => of(new ShiftManagementActions.FetchAllShiftsFailure())),
        ),
      ),
    ),
  );

  fetchLineShifts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TShiftManagementActionType.FetchLineShifts),
      switchMap((action: ShiftManagementActions.FetchLineShifts) =>
        from(this.APIHelper.presentLoading()).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action] as const),
        ),
      ),
      switchMap(([loaderEl, action]) =>
        this.mmDataService.getLineShifts(action.payload).pipe(
          finalize(() => this.APIHelper.dismissLoadingV2(loaderEl)),
          map((res) => new ShiftManagementActions.FetchLineShiftsSuccess(res)),
          catchError(() => of(new ShiftManagementActions.FetchLineShiftsFailure())),
        ),
      ),
    ),
  );
}
